(function () {
  'use strict';

  var previousFocus = null;

  function resetVideo(modal) {
    var video = modal && modal.querySelector('[data-es-demo-video]');
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (error) {}
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    resetVideo(modal);
    modal.hidden = true;
    document.body.classList.remove('es-product-demo-modal-open');
    if (previousFocus && previousFocus.focus) previousFocus.focus();
    previousFocus = null;
  }

  function openModal(section, trigger) {
    var modal = section.querySelector('[data-es-demo-modal]');
    if (!modal) return;

    document.querySelectorAll('[data-es-demo-modal]:not([hidden])').forEach(function (other) {
      if (other !== modal) closeModal(other);
    });

    previousFocus = trigger || document.activeElement;
    modal.hidden = false;
    document.body.classList.add('es-product-demo-modal-open');

    var closeButton = modal.querySelector('.es-product-demo-modal__close');
    var video = modal.querySelector('[data-es-demo-video]');

    if (closeButton) closeButton.focus();

    if (video) {
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }
  }

  function init(section) {
    if (!section || section.dataset.esDemoInitialized === 'true') return;
    section.dataset.esDemoInitialized = 'true';

    var trigger = section.querySelector('[data-es-demo-open]');
    var modal = section.querySelector('[data-es-demo-modal]');

    if (trigger) {
      trigger.addEventListener('click', function () {
        openModal(section, trigger);
      });
    }

    if (modal) {
      modal.querySelectorAll('[data-es-demo-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          closeModal(modal);
        });
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-es-product-demo]').forEach(init);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = document.querySelector('[data-es-demo-modal]:not([hidden])');
    if (modal) closeModal(modal);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
